<script lang="ts">
	// The design system's SpecRow (design/components/surfaces/SpecRow.jsx): a
	// label on the leading edge, its value on the trailing edge, a hairline
	// under both. The value is mono by default, because it is usually a number.

	interface Props {
		label: string;
		value: string;
		mono?: boolean;
		onInk?: boolean;
		valueTestId?: string;
	}

	let { label, value, mono = true, onInk = false, valueTestId }: Props = $props();
</script>

<div class="row" class:on-ink={onInk}>
	<span class="label">{label}</span>
	<span class="value ltr-numerals" class:mono data-testid={valueTestId}>{value}</span>
</div>

<style>
	.row {
		display: flex;
		justify-content: space-between;
		gap: 8px;
		padding: 9px 0;
		border-block-end: 1px solid var(--border-inset);
		font-size: var(--text-2xs);
		color: var(--ink-body);
	}

	.label {
		color: var(--ink-muted);
	}

	.value {
		font-family: var(--font-sans);
	}

	.value.mono {
		font-family: var(--font-mono);
	}

	.on-ink {
		border-block-end-color: var(--rule-on-ink);
		color: var(--on-ink-body);
	}

	.on-ink .label {
		color: var(--on-ink-muted);
	}
</style>
